
export const environment = {
  production: false,
  baseUrl: 'https://dev-alfaforce-api.dotitsrl.it/api/v1/',
  baseUrlV2: 'https://dev-alfaforce-api.dotitsrl.it/api/v2/',
  imagePath: '',
  home: 'attivita',
  firebase: {
    apiKey: 'AIzaSyBofAe244PQMu26TmoXMU-HLpETTJQ0uCM',
    authDomain: 'alfaforce-68b3c.firebaseapp.com',
    projectId: 'alfaforce-68b3c',
    storageBucket: 'alfaforce-68b3c.firebasestorage.app',
    messagingSenderId: '102051100675943837097',
    appId: '1:894262216361:android:90558ec577791e861fcbb8',
  },
};
